import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { nowToolConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ToolStack = createStackNavigator();

const ToolNavigator = () => {
  return (
    <ToolStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {nowToolConfig.map(({ Component, name }) => (
        <ToolStack.Screen key={name} name={name} component={Component} />
      ))}
    </ToolStack.Navigator>
  );
};

export { ToolNavigator };
